"use strict";

import React, {Fragment, useState} from 'react';
import dateFormat from "dateformat";
import AccountAddressDisplay from "../../account/component/AccountAddressDisplay";
import OrderLineItems from "./OrderLineItems";
import OrderSampleItems from "./OrderSampleItems";
import OrderTrailingSummary from "./OrderTrailingSummary";
import {myTimestampToDate} from "../../time";
import OrderShipments from "./OrderShipments";
import Icons from "../../component/Icon";
import OrderPaymentMethodDisplay from "./OrderPaymentMethodDisplay";
import OrderAdjustments from "./OrderAdjustments";

const Order = ({isTopsOrder=false,
                   order={},
                   billingAddress={},
                   shippingAddress={},
                   lineItems=[],
                   sampleItems=[],
                   shipments=[]}) => {
    const [showShipments, setShowShipments] = useState(false);

    function toggleShowShipments(){
        setShowShipments(!showShipments);
    }

    function onShowShipmentsClick(e){
        e.preventDefault();
        toggleShowShipments();
    }

    return (
        <div className="" style={{marginBottom: '1.5rem',}}>
            <div className="row--flex" style={{alignItems: 'center', marginBottom: '1.5rem'}}>
                <h3 className="is-marginless order__info__column">
                    #{ !isTopsOrder ? 'W-' : ''}{!isTopsOrder ? order.order_id : order.tops_order_id}
                </h3>
                {!!order.mail_code &&
                <p className="is-marginless order__info__column">
                    Keycode: <strong>{order.mail_code}</strong>
                </p>
                }
                <p className="is-marginless order__info__column">
                    Date: {dateFormat(myTimestampToDate(order.date_ordered), 'm/d/yy - h:MM TT')}
                </p>
            </div>
            <div className="row--flex" style={{marginBottom: '2rem',}}>
                <div className="order__info__column">
                    <h5 className="">Contact:</h5>
                    <AccountAddressDisplay address={billingAddress} email={order.email} />
                </div>
                <div className="order__info__column">
                    { showShipments &&
                        <Fragment>
                            <h5 className="">Shipment{shipments.length > 1 ? 's' : ''}:</h5>
                            <OrderShipments shipments={shipments} />
                            <a href="#" title=""
                               className="btn__secondary--outline btn--small"
                               onClick={onShowShipmentsClick} >
                                &nbsp; Close Shipment{shipments.length > 1 ? 's' : ''}
                                <Icons name="right" />
                            </a>
                        </Fragment>
                        ||
                        <Fragment>
                            <h5 className="">Shipping:</h5>
                            <div>
                                <AccountAddressDisplay address={shippingAddress} />
                                { !!order.shipping_method &&
                                <Fragment>
                                    <strong>Method:</strong> {order.shipping_method}
                                </Fragment>
                                }
                            </div>
                            { !!shipments.length &&
                            <div>
                                <a href="#" title=""
                                   className="btn__primary--outline btn--small"
                                   onClick={onShowShipmentsClick} >
                                    <span className="label__light-gray label--round">
                                        {shipments.length}
                                    </span>
                                     &nbsp; Shipment{shipments.length > 1 ? 's' : ''}
                                    <Icons name="right" />
                                </a>
                            </div>
                            }
                        </Fragment>
                    }
                </div>
                {!showShipments &&
                    <div className="order__info__column">
                        <h5 className="">Payment:</h5>
                        <OrderPaymentMethodDisplay paymentMethod={order.payment_method || ''} paymentDetails={order.payment_details || {}} />
                    </div>
                }
            </div>
            <table className="cart-line-items">
                <thead>
                <tr>
                    <th scope="col" className="line-item-action-col">&nbsp;</th>
                    <th scope="col" className="line-item-quantity-col">Quantity</th>
                    <th scope="col" className="line-item-description-col">Description</th>
                    <th scope="col" className="line-item-price-col">Price</th>
                    <th scope="col" className="line-item-subtotal-col">Subtotal</th>
                    <th scope="col" className="line-item-extra-charges-col">Fees</th>
                    <th scope="col" className="line-item-discount-col">Discount</th>
                    <th scope="col" className="line-item-total-col">Total</th>
                </tr>
                </thead>
                {!!lineItems.length &&
                <tbody className="line-items">
                    <OrderLineItems isTopsOrder={isTopsOrder} lineItems={lineItems}/>
                </tbody>
                }
                <OrderAdjustments adjustments={order?.order_adjustments?.credit?.adjustments || []}
                                  type="credit"
                                  colSpan="8"
                                  title="Adjustment Discount" />
                <OrderAdjustments adjustments={order?.order_adjustments?.debit?.adjustments || []}
                                  type="debit"
                                  colSpan="8"
                                  title="Adjustment Fee" />
            </table>
            { !!sampleItems.length &&
                <OrderSampleItems isTopsOrder={isTopsOrder} sampleItems={sampleItems} />
            }
            <OrderTrailingSummary isTopsOrder={isTopsOrder} order={order} />
        </div>
    );
};

export default Order;
